import { useState } from "react";

import WorldMapImg  from "../../assets/images/contactus/world-map-network.webp";
import LocationIcon from "../../assets/icons/contactus/location.svg";
import EmailIcon    from "../../assets/icons/contactus/email.svg";
import PhoneIcon    from "../../assets/icons/contactus/phone.svg";

/* ─────────────────────────────────────────────
   PREFIX: cu-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .cu-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }

  /* ── HERO ── */
  .cu-hero {
    position: relative;
    width: 100%;
    height: 400px;
    background: #0D1117;
    overflow: hidden;
    display: flex;
    align-items: center;
  }
  .cu-hero__map {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    object-fit: cover;
    object-position: center;
    opacity: 0.85;
  }
  .cu-hero__inner {
    position: relative;
    z-index: 1;
    max-width: 1600px;
    width: 100%;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }
  .cu-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
  }

  /* ── FORM SECTION ── */
  .cu-form-section {
    background: #1A1A1A;
    padding-top: 100px;
    padding-bottom: 100px;
  }
  .cu-form-section__inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 246px;
    padding-right: 246px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 84px;
    align-items: center;
  }
  .cu-form-section__heading {
    font-family: 'Roboto', sans-serif;
    font-size: 40px;
    font-weight: 700;
    color: #ffffff;
    line-height: 120%;
    margin-bottom: 14px;
  }
  .cu-form-section__desc {
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 140%;
  }

  /* ── FORM CARD ── */
  .cu-form-card {
    border: 1px solid #743FAC;
    border-radius: 12px;
    padding: 44px;
    background: #000000;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  .cu-form-card__field {
    width: 100%;
    background: #1A1A1A;
    border: 1px solid #3C3C3C;
    border-radius: 8px;
    padding: 13px 14px;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #74767A;
    outline: none;
    transition: border-color 0.2s ease;
    resize: none;
  }
  .cu-form-card__field::placeholder { color: #74767A; }
  .cu-form-card__field:focus { border-color: #743FAC; }
  .cu-form-card__textarea { height: 120px; }
  .cu-form-card__btn {
    width: 100%;
    padding: 13px;
    background: #743FAC;
    border: none;
    border-radius: 5px;
       font-family: 'Roboto', sans-serif;

    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    cursor: pointer;
    transition: background 0.2s ease;
    margin-top: 4px;
  }
  .cu-form-card__btn:hover { background: #8B52CC; }

  /* ── INFO CARDS ── */
  .cu-info-section {
    background: #1A1A1A;
    padding-bottom: 80px;
  }
  .cu-info-section__inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
  }
  .cu-info-card {
    border: 1px solid #743FAC;
    border-radius: 12px;
    padding: 24px;
    background: #000000;
  }
  .cu-info-card__icon-wrap {
    width: 84px;
    height: 84px;
    // background: #2a1a40;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
  }
  .cu-info-card__icon-wrap svg {
    width: 84px;
    height: 84px;
  }
  .cu-info-card__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 24px;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 14px;
  }
  .cu-info-card__text {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 160%;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .cu-hero { height: 300px; }
    .cu-hero__inner { padding-left: 32px; padding-right: 32px; }
    .cu-hero__title { font-size: 24px; }
    .cu-form-section { padding-top: 48px; padding-bottom: 48px; }
    .cu-form-section__inner { padding-left: 32px; padding-right: 32px; gap: 40px; grid-template-columns: 1fr ;}
    .cu-form-section__heading { font-size: 24px; }
    .cu-info-section { padding-bottom: 48px; }
    .cu-info-section__inner {
      padding-left: 32px; padding-right: 32px;
      grid-template-columns: 1fr 1fr;
    }
      .cu-info-card {padding: 18px;}
      .cu-info-card__icon-wrap {width: 64px;height: 64px; margin-bottom: 16px;}
     .cu-info-card__icon-wrap img {width: 64px;height: 64px; }
     .cu-info-card__title {font-size: 22px;margin-bottom:10px;}
      .cu-info-card__text {font-size: 14px;}
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .cu-hero { height: 200px; }
    .cu-hero__inner { padding-left: 16px; padding-right: 16px; }
    .cu-hero__title { font-size: 30px; }
    .cu-form-section { padding-top: 40px; padding-bottom: 40px; }
    .cu-form-section__inner {
      padding-left: 16px; padding-right: 16px;
      grid-template-columns: 1fr;
      gap: 24px;
    }
      .cu-form-card { padding: 24px 17px 28px 17px; gap: 15px;}
      .cu-form-card__field {font-size: 14px; padding: 14px 24px;}
      .cu-form-card__btn {font-size: 14px; padding: 14px 24px;border-radius: 5px;}
    .cu-form-section__heading { font-size: 20px; }
    .cu-info-section { padding-bottom: 50px; }
    .cu-info-section__inner { padding-left: 16px; padding-right: 16px; gap: 15px;grid-template-columns: 1fr; }
    .cu-info-card {padding: 18px 14px 38px 25px;}
    .cu-info-card__icon-wrap {width: 58px;height: 58px; margin-bottom: 16px;}
     .cu-info-card__icon-wrap img {width: 58px;height: 58px; }
     .cu-info-card__title {font-size: 20px;}
     .cu-info-card__text {font-size: 14px;}
  }
`;

function HeroSection() {
  return (
    <section className="cu-hero">
      <img className="cu-hero__map" src={WorldMapImg} alt="World map network" />
      <div className="cu-hero__inner">
        <h1 className="cu-hero__title">Contact Us</h1>
      </div>
    </section>
  );
}

function FormSection() {
  const [form, setForm] = useState({ name: "", phone: "", email: "", message: "" });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    console.log("Form submitted:", form);
  };

  return (
    <section className="cu-form-section">
      <div className="cu-form-section__inner">
        <div className="cu-form-section__left">
          <h2 className="cu-form-section__heading">Let's start the conversation!</h2>
          <p className="cu-form-section__desc">
            Are you a thought leader driving change in your industry? We're always looking to collaborate with bold minds and fresh perspectives. If you've got insights to share, we've got the platform.
          </p>
        </div>
        <div className="cu-form-card">
          <input
            className="cu-form-card__field"
            type="text"
            name="name"
            placeholder="Name"
            value={form.name}
            onChange={handleChange}
          />
          <input
            className="cu-form-card__field"
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={form.phone}
            onChange={handleChange}
          />
          <input
            className="cu-form-card__field"
            type="email"
            name="email"
            placeholder="Email"
            value={form.email}
            onChange={handleChange}
          />
          <textarea
            className="cu-form-card__field cu-form-card__textarea"
            name="message"
            placeholder="Message"
            value={form.message}
            onChange={handleChange}
          />
          <button className="cu-form-card__btn" onClick={handleSubmit}>
            Send
          </button>
        </div>
      </div>
    </section>
  );
}

function InfoSection() {
  return (
    <section className="cu-info-section">
      <div className="cu-info-section__inner">
        <div className="cu-info-card">
          <div className="cu-info-card__icon-wrap">
            <img src={LocationIcon} alt="Location" />
          </div>
          <h3 className="cu-info-card__title">Location</h3>
          <p className="cu-info-card__text">
            ADOR POWERTRON Ador Warrior City Campus,<br />
            Plot No 51, D-II Block, Ramnagar, MIDC, Chinchwad,<br />
            Pune, 411019
          </p>
        </div>
        <div className="cu-info-card">
          <div className="cu-info-card__icon-wrap">
            <img src={EmailIcon} alt="Email" />
          </div>
          <h3 className="cu-info-card__title">Email Us</h3>
          <p className="cu-info-card__text">digitalmarketing@adorpower.Com</p>
        </div>
        <div className="cu-info-card">
          <div className="cu-info-card__icon-wrap">
            <img src={PhoneIcon} alt="Phone" />
          </div>
          <h3 className="cu-info-card__title">Call Us</h3>
          <p className="cu-info-card__text">+ 91 877 054 5978</p>
        </div>
      </div>
    </section>
  );
}

export default function ContactUs() {
  return (
    <>
      <style>{CSS}</style>
      <div className="cu-page">
        <HeroSection />
        <FormSection />
        <InfoSection />
      </div>
    </>
  );
}